import * as lodash from "lodash/fp"
import * as BusinessProcess from "@/lib/Util/Types/Masterdata/BusinessProcess/BusinessProcess"

export function prepare(x: BusinessProcess.T | null) {
    if (x) {
        const clone = lodash.cloneDeep(x)
        return BusinessProcess.addValidationProtocol(clone)
    }
    return null
}